import * as _ from "lodash";
import { OnboardingRepo } from "@services/onboarding.repo";
import { FileItems } from "../FileItems";
import { extractErrorMessage } from "@common/utils/errorUtils";

import * as moment from "moment";
// import { Component, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';

class registeredClientController implements angular.IOnInit {
  public files: FileItems[];
  public currentInput: any;
  private fileControl: HTMLInputElement;
  public clientFiles: FileItems[];
  public client: string;
  auth: any;
  public isClientLoading = true;
  public isFileLoading = true;

  /** @ngInject */
  constructor(
    private onboardingRepo: OnboardingRepo,
    private $state: angular.ui.IStateService,
    private notifyjs: any,
    private $window: angular.IWindowService,
    private authService: any
  ) {
    var _this = this;
    _this.auth = authService;
    _this.client = authService.getUserName();
  }

  $onInit() {
    this.loadFileData();
    this.loadClientData();
    this.fileControl = document.getElementById(
      "uploadFile"
    ) as HTMLInputElement;
    this.fileControl.addEventListener(
      "change",
      this.uploadFileEventChange.bind(this)
    );
  }

  loadFileData() {
    this.isFileLoading = true;
    this.files = [];
    this.onboardingRepo
      .getFiles()
      .then((files) => {
        this.files = files;
        this.isFileLoading = false;
      })
      .catch((err) => this.notifyjs(`Failed to retrieve file: ${extractErrorMessage(err)}`));
  }

  loadClientData() {
    this.isClientLoading = true;
    this.clientFiles = [];
    this.onboardingRepo
      .getClientFiles(this.client)
      .then((files) => {
        this.clientFiles = files;
        this.isClientLoading = false;
      })
      .catch((err) => this.notifyjs(`Failed to retrieve file: ${extractErrorMessage(err)}`));
  }

  getFileName(file) {
    return file.key.split(`accountForms/`)[1];
  }

  getClientFileName(file) {
    return file.key.split(`clients/${this.client}/`)[1];
  }

  downloadFileUrl(file) {
    this.$window.open(file.url, "_blank");
  }

  openFile() {
    document.getElementById("uploadFile").click();
  }

  deleteFile(file) {
    this.onboardingRepo.deleteFile(file.key).then(() => {
      this.loadClientData();
    });
  }

  uploadFileEventChange(event) {
    this.isClientLoading = true;
    let file = event.target.files[0];
    this.onboardingRepo
      .uploadClientFile(file, this.client)
      .then((res) => {
        this.loadClientData();
      })
      .catch((err) => this.notifyjs(`Failed to upload file: ${extractErrorMessage(err)}`));
  }
}

export const registeredClient: angular.IComponentOptions = {
  template: require("./registeredClient.html"),
  controller: registeredClientController,
};



// WEBPACK FOOTER //
// ./src/app/onboarding/registeredClient/registeredClient.ts